import React, { useState, useEffect } from 'react';
import { useLazyQuery } from "@apollo/client";
import { Box, Flex, Grid, Heading, Text, Icon } from "@chakra-ui/react";
import { FaMicrochip, FaCogs, FaGraduationCap, FaPalette, FaHeartbeat, FaThLarge, FaSeedling, FaLaptopCode } from 'react-icons/fa';
import { HIED } from "../../constants"
import {
  DYNOCATEGORIES
} from "../../graphql/queries";
import { useStore } from "../../Store";
import SubCategorySkeleton from '../SubCategorySkeleton';


export const HigherEd = ({ product, type }) => {

  const [dynoSubCategory, setDynoSubCategory] = useState([]);
  const {updateStates} = useStore((state) => state);

  const category = {
    "Technology": {
      icon: FaMicrochip,
      description: "Focuses on the application of scientific knowledge for practical purposes, including tools, systems, and devices."
    },
    "Engineering": {
      icon: FaCogs,
      description: "Involves designing, building, and maintaining structures, machines, and systems using math and science principles."
    },
    "Education": {
      icon: FaGraduationCap,
      description: "The study and practice of teaching and learning methods, aiming to facilitate knowledge and personal development."
    },
    "Arts": {
      icon: FaPalette,
      description: "Encompasses creative disciplines like visual arts, music, dance, and literature that express human imagination."
    },
    "Health Sciences": {
      icon: FaHeartbeat,
      description: "Covers medical and health-related fields focused on improving physical and mental well-being."
    },
    "Other": {
      icon: FaThLarge,
      description: "Includes interdisciplinary or uncategorized fields that don't neatly fit into the defined categories."
    },
    "Agriculture": {
      icon: FaSeedling,
      description: "Concerned with farming, food production, animal care, and sustainable land use."
    },
    "Computer Science": {
      icon: FaLaptopCode,
      description: "The study of algorithms, software development, and systems that process information and enable digital technology."
    }
  };

  const [getDynosCategories, {loading}] = useLazyQuery(DYNOCATEGORIES,
    {
      onCompleted: (data) => {
        const dynoCategories = data.dynoCategories.map(cat => ({
          id: cat.id,
          name: cat.name,
          icon: category[cat.name]?.icon || "FaThLarge",
          description: category[cat.name]?.description || ""
        }));
        setDynoSubCategory(dynoCategories)
      }
    }
  )

  useEffect(() => {
    getDynosCategories({
      variables: {
        where: {
          parentCategory: {
            name: {
              equals: HIED
            }
          }
        }
      }
    })
  }, []);

  return (
    loading ?
    <SubCategorySkeleton /> :
    <Box w="100%">
      <Heading as='h3' size='lg' mb={4}>Choose Your Academic Field</Heading>
      <Text fontSize="md" mb={8} color="gray.600">Explore diverse academic disciplines and find your passion</Text>

      <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }} gap={6} maxW="7xl" mx="auto">
        {dynoSubCategory.map((category) => (
          <Box
            key={category.id}
            onClick={() =>  updateStates({
              [type]: {...product, subCategory: category}
            })
            }
            cursor="pointer"
            p={6}
            rounded="lg"
            shadow="md"
            _active={{ transform: "scale(0.98)" }}
            bg={product.subCategory.id === category.id ? "blue.100" : "white"}
            color="#000"
            _hover={{
              bg: "blue.100",
            }}
          >
            <Flex align="start" gap={4}>
              <Box display="flex" alignItems="center" justifyContent="center">
                <Icon as={category.icon} color="blue.500" boxSize={6}/>
              </Box>
              <Box>
                <Heading as="h3" size="sm" mb={1}>{category.name}</Heading>
                <Text fontSize="sm" color="gray.600">{category.description}</Text>
              </Box>
            </Flex>
          </Box>
        ))}
      </Grid>
    </Box>
  );
};

